import { render, staticRenderFns } from "./PeopleLivelihood.vue?vue&type=template&id=49c046cc&scoped=true"
import script from "./PeopleLivelihood.vue?vue&type=script&lang=js"
export * from "./PeopleLivelihood.vue?vue&type=script&lang=js"
import style0 from "./PeopleLivelihood.vue?vue&type=style&index=0&id=49c046cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c046cc",
  null
  
)

export default component.exports